// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const blockName = "ModuleWrapper__blockName__+DirL";
export const bold = "700";
export const flexLayout = "ModuleWrapper__flexLayout__IZps-";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const header = "ModuleWrapper__header__Bqql3";
export const headerInner = "ModuleWrapper__headerInner__0nBw0";
export const medium = "500";
export const moduleWrapper = "ModuleWrapper__moduleWrapper__vUMd4";
export const noPadding = "ModuleWrapper__noPadding__vR4HW";
export const regular = "400";
export const rightArrow = "ModuleWrapper__rightArrow__ST4hY";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const subtitle = "ModuleWrapper__subtitle__HR7Gf";
export const title = "ModuleWrapper__title__5uqnL";
export const tooltipIconWrapper = "ModuleWrapper__tooltipIconWrapper__CE0bT TooltipIcon__tooltipIconWrapper__oUGNC";
export const withChevron = "ModuleWrapper__withChevron__X3elS";